import 'vite/modulepreload-polyfill';

//remove bootstrap import, because every element should get its own javascript file with initialization
//for example take a look at /bootstrap-fluid-components/Resources/Private/Components/Popover
//import "bootstrap";
//https://github.com/fontsource/fontsource
import "@fontsource/roboto";

import "../Scss/styles.scss";
import "../Scss/fontawesome.scss";

import "./modules/CookieConsent";

import Tooltip from "bootstrap/js/dist/tooltip";
import Collapse from "bootstrap/js/dist/collapse";
import Dropdown from "bootstrap/js/dist/dropdown";
import Alert from "bootstrap/js/dist/alert";
import Tab from "bootstrap/js/dist/tab";
import Scrollspy from "bootstrap/js/dist/scrollspy";
import {Modal} from "bootstrap/js/dist/modal";

// core version + navigation, pagination modules:
import Swiper from 'swiper';
import {Navigation, Pagination} from 'swiper/modules';
// import Swiper and modules styles
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';


function initSwiper() {
  const swiper = new Swiper('.swiper', {
    // configure Swiper to use modules
    modules: [Navigation, Pagination],
    // Optional parameters
    loop: true,
    autoHeight: true,

    // If we need pagination
    pagination: {
      el: '.swiper-pagination',
    },

    // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    }
  });

  // Add active class to the current bullet on slide change
  swiper.on('slideChange', function () {
    const activeIndex = swiper.realIndex;
    console.log(activeIndex)
    document.querySelectorAll('.swiper-pagination-bullet').forEach((bullet, index) => {
      if (index === activeIndex) {
        bullet.classList.add('swiper-pagination-bullet-active');
      } else {
        bullet.classList.remove('swiper-pagination-bullet-active');
      }
    });
  });
}

if (import.meta.hot) {
  import.meta.hot.accept();
}


document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-bs-toggle="tooltip"]').forEach(element => {
    Tooltip.getOrCreateInstance(element);
  });
  // document.querySelectorAll('.collapse').forEach(element => {
  //   Collapse.getOrCreateInstance(element);
  // });
  document.querySelectorAll('[data-bs-toggle="dropdown"]').forEach(element => {
    Dropdown.getOrCreateInstance(element);
  });
  document.querySelectorAll('[data-bs-toggle="tab"]').forEach(element => {
    Tab.getOrCreateInstance(element);
  });
  document.querySelectorAll('[data-bs-spy="scroll"]').forEach(element => {
    Scrollspy.getOrCreateInstance(element);
  });
  document.querySelectorAll('.alert').forEach(element => {
    Alert.getOrCreateInstance(element);
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const items = document.querySelectorAll('.glightbox');
  if (items.length > 0) {
    import("./modules/lightbox" /* webpackChunkName: "glightbox" */).then(({default: init}) => {
      init();
    })
  }

  // https://github.com/ganlanyuan/tiny-slider
  const sliders = document.querySelectorAll('.tiny-slider');
  if (sliders.length) {
    import("./modules/tiny-slider").then(({default: initSlider}) => {
      initSlider(sliders);
    })
  }

  const competencematrix = document.querySelector('.competence-matrix-form');
  if (competencematrix != null && competencematrix.length) {
    import("./modules/competence-matrix").then(({default: init}) => {
      init(competencematrix);
    })
    if (window.innerWidth < 992) {
      import("./modules/competence-matrix-mobile").then(({default: initMobile}) => {
        initMobile(competencematrix); // Init mobile-specific functionality
      });
    }
  }

  const downloadFileFormLinks = document.querySelectorAll('.form-modal');
  if (downloadFileFormLinks != null && downloadFileFormLinks.length) {
    import("./modules/formInModal").then(({default: init}) => {
      downloadFileFormLinks.forEach(element => {
        init(element);
      })
    })
  }

  const navigation = document.getElementById('main-navigation');
  if (navigation) {
    import('./modules/navigation.js').then(module => {
      const init = module.default;
      init(navigation);
    }).catch(err => {
      console.error('Error loading the navigation module:', err);
    });
  }


  const eventSlider = document.querySelectorAll('.swiper-news');
  if (eventSlider != null && eventSlider.length) {
    import("./modules/eventList.js").then(({default: initEventSwiper}) => {
      initEventSwiper();
    })
  }

  const newsSlider = document.querySelectorAll('.swiper-news');
  if (newsSlider != null && newsSlider.length) {
    import("./modules/newsList.js").then(({default: initNewsSwiper}) => {
      initNewsSwiper();
    })
  }

  const newsAjax = document.querySelectorAll('.news-tags');
  if (newsAjax != null && newsAjax.length) {
    import("./modules/newsListAjaxFilter.js").then(({default: newsListAjaxFilter}) => {
      newsListAjaxFilter();
    })
  }

  const headerSlider = document.querySelectorAll('.swiper-header');
  if (headerSlider != null && headerSlider.length) {
    import("./modules/headerSlider.js").then(({default: swiper}) => {
      swiper();
    })
  }
  const eventInformationWrapper = document.getElementById('event-register-information');
  if (eventInformationWrapper != null) {
    import("./modules/eventForm.js").then(({default: initEventInformation}) => {
      initEventInformation(eventInformationWrapper);
    })
  }


});

// wait for the vitejs backend to reload correctly after vite.config.js or package.json changes
if (process.env.NODE_ENV !== "production") {
  let retries = 5;
  const {fetch: originalFetch} = window;

  window.fetch = async (...args) => {
    let [resource] = args;
    if (resource.includes(`:${import.meta.env.VITE_DEV_PORT ?? 5173}`)) {
      try {
        const response = await originalFetch(...args);
        if (!response.ok) {
          if (retries > 0) {
            retries--;
            await new Promise(resolve => setTimeout(resolve, 1000));
            return await originalFetch(...args);
          }
        }
      } catch (e) {
        console.log(e);
      }
    }
    return await originalFetch(...args);
  };
}


//Video
document.addEventListener("DOMContentLoaded", function () {
  const video = document.getElementById('io-link-video');
  const playButton = document.getElementById("play_button");

  if (video != null) {
    video.controls = false;

    function togglePlayPause() {
      if (video.paused) {
        video.play();
        playButton.style.display = "none";
      } else {
        video.pause();
        playButton.style.display = "block";
      }
    }

    playButton.addEventListener("click", togglePlayPause);
    video.addEventListener("click", togglePlayPause);

    video.addEventListener("pause", function () {
      playButton.style.display = "block";
    });
  }
});


//Search - add the input value to no results page
document.addEventListener('DOMContentLoaded', function () {
  const inputEl = document.getElementById("ke_search_sword");
  const results = document.getElementById('noResults');

  function getSearchQueryFromUrl() {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('tx_kesearch_pi1[sword]');
  }

  function updateResultsText(searchText) {
    if (results !== null) {
      results.innerHTML = `"${searchText}"`;
    }
  }

  const searchQuery = getSearchQueryFromUrl();
  updateResultsText(searchQuery);

  const searchButton = document.getElementById("searchButton")
  if (searchButton != null && searchButton.length > 0) {
    searchButton.addEventListener("click", function () {
      const searchText = inputEl.value.trim();
      if (searchText) {
        window.location.href = `${document.getElementById("form_kesearch_pi1").action}?tx_kesearch_pi1[sword]=${encodeURIComponent(searchText)}`;
      }
    });
  }
});


//remove show from opened element in nav
document.addEventListener('DOMContentLoaded', function () {
  const mainNav = document.getElementById('main-navigation');

  const observer = new MutationObserver((mutations) => {
    mutations.forEach(mutation => {
      if (mutation.type === 'childList') {
        //console.log(mutation.addedNodes, mutation.removedNodes);
      } else if (mutation.type === 'attributes') {
        //console.log(mutation.target);
      }
    });
  });


  const config = {childList: true, attributes: true, subtree: true};

  observer.observe(mainNav, config);

  const searchBtn = document.querySelector('[data-bs-target="#io-link-search"]');
  const navBtn = document.querySelector('[data-bs-target="#io-link-nav"]');
  const searchCollapse = document.getElementById('io-link-search');
  const navCollapse = document.getElementById('io-link-nav');

  searchBtn.addEventListener('click', function () {
    if (navCollapse.classList.contains('show')) {
      navCollapse.classList.remove('show');
    }
  });

  navBtn.addEventListener('click', function () {
    if (searchCollapse.classList.contains('show')) {
      searchCollapse.classList.remove('show');
    }
  });
});




